import styled from "styled-components";
import {MEDIA_QUERIES} from "constants/StyleConstants.js";

export const StyleForm = styled.form.attrs(() => ({
  autoComplete: "off"
}))`
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  height: ${(props) => props.height};

  @media only screen and (min-width: ${MEDIA_QUERIES.tablet_min_width}) and (max-width: ${MEDIA_QUERIES.tablet_max_width}) {
    max-width: ${(props) => props.tabletMaxWidth};
  }
`;
